import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b2f39d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mq-checkbox" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-mask" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _ctx.checked,
      autocomplete: "off",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event)))
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}